<template>
  <div class="page-search">
    <ml-search-bar
      @handle-search="handleSearch"
      :value.sync="searchValue"
      placeholder="搜你想搜看你想看"
    />
    <div class="search-content">
      <div class="search-title">
        <p>历史搜索</p>
        <img
          v-show="searchHistories.length > 0"
          @click="clearHistories"
          src="../../assets/video/delete@2x.png"
          alt=""
        />
      </div>
      <ul class="search-history" @click="completeSearchHistory">
        <li
          v-for="(history, index) in searchHistories.slice(0, 15)"
          :key="index"
        >
          {{ history }}
        </li>
      </ul>
      <div class="search-title">
        <p>热门搜索</p>
      </div>
      <ul class="hot-tags">
        <li
          v-for="tag in hotTags"
          :key="tag.id"
          :class="{ active: selectedTag === tag.name }"
          @click="handleSelectTag(tag.name)"
        >
          <img
            v-if="selectedTag === tag.name"
            src="../../assets/video/complete@2x.png"
            alt=""
          />
          <span>{{ tag.name }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import completeIcon from "@/assets/video/complete@2x.png";
import * as history from "@/utils/searchHistory";
import { getHotTags } from "@/api/video";

export default {
  name: "VideoSearch",
  data() {
    return {
      completeIcon,
      searchHistories: history.getAll(),
      searchValue: "",
      selectedTag: "",
      hotTags: []
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.hotTags = await getHotTags();
    },
    async handleSearch() {
      if (this.searchValue.length === 0) return;
      await this.$router.push({
        name: "videoResult",
        params: { value: this.searchValue },
        query: { tag: this.selectedTag }
      });

      history.setItem(this.searchValue);
      this.searchHistories = history.getAll();
      this.searchValue = "";
    },
    clearHistories() {
      history.clear();
      this.searchHistories = history.getAll();
    },
    completeSearchHistory(event) {
      if (event.target.nodeName === "LI") {
        this.searchValue = event.target.innerHTML.trim();
      }
    },
    handleSelectTag(tagName) {
      this.selectedTag = tagName;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-search {
  min-height: 100vh;
  .search-content {
    padding: 64px 0;
    .search-title {
      padding: 0 15px;
      margin-bottom: 17px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      p {
        font-size: 15px;
        font-weight: 500;
        color: rgba(33, 40, 50, 1);
        line-height: 21px;
      }
      img {
        width: 18px;
        height: 18px;
      }
    }
    .search-history {
      margin-bottom: 30px;
      padding: 0 11px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      li {
        margin: 0 4px 10px 4px;
        border-radius: 16px;
        padding: 0 8px;
        width: 80px;
        height: 32px;
        line-height: 32px;
        color: rgba(61, 61, 61, 1);
        background: rgba(246, 246, 250, 1);
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .hot-tags {
      padding: 0 15px;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: auto;
      grid-gap: 10px;
      > li {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 36px;
        background: rgba(237, 242, 244, 1);
        border-radius: 18px;
        font-weight: 400;
        color: rgba(61, 61, 61, 1);
        > img {
          margin-right: 6px;
          width: 12px;
          height: 12px;
          line-height: 36px;
        }
        > span {
          font-size: 14px;
          font-weight: 400;
          color: rgba(61, 61, 61, 1);
        }
      }
      .active {
        > span {
          font-weight: 500;
        }
      }
    }
  }
}
</style>
